import { useCallback, useState } from 'react';

import { Button } from '@ui/uikit/components/common/Button';

import type {
  ApplicationValidationSummaryProps,
  ControlsProps,
  IsSqrvVotingPowerUsed,
  IsValidationFinished,
} from '../ApplicationValidationSummary';
import styles from './ApplicationValidationControls.module.scss';
import { ApplicationValidationVotesModal } from './ApplicationValidationVotesModal/ApplicationValidationVotesModal';

type ApplicationValidationControlsProps = ControlsProps &
  IsValidationFinished &
  IsSqrvVotingPowerUsed &
  Pick<ApplicationValidationSummaryProps, 'isLoading'>;

export const ApplicationValidationControls = ({
  onVote,
  onShowDetails,
  hasVoted,
  votesTableModel,
  isValidationFinished,
  isSqrvVotingPowerUsed,
  isLoading,
}: ApplicationValidationControlsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => setIsOpen(true), []);
  const handleClose = useCallback(() => setIsOpen(false), []);

  const isVotersDisabled = votesTableModel?.votersCount === 0 || isLoading;

  return (
    <div className={styles.container}>
      <div className={styles.topButtons}>
        <Button
          size="medium"
          variant="secondary"
          width="100%"
          onClick={handleOpen}
          disabled={isVotersDisabled}
        >
          Voters
        </Button>
        <Button size="medium" variant="secondary" width="100%" onClick={onShowDetails}>
          Details
        </Button>
      </div>
      {!isValidationFinished && (
        <Button size="medium" onClick={onVote} width="100%" disabled={hasVoted}>
          {hasVoted ? 'Voted' : 'Vote on Project'}
        </Button>
      )}
      <ApplicationValidationVotesModal
        isOpen={isOpen}
        onClose={handleClose}
        isValidationFinished={isValidationFinished}
        isSqrvVotingPowerUsed={isSqrvVotingPowerUsed}
        {...votesTableModel}
      />
    </div>
  );
};
